@if (translationKeys().length) {
  <div
    role="alert"
    class="flex items-start gap-2 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800"
  >
    <mat-icon
      fontIcon="error"
      aria-hidden="true"
      class="icon-sm material-symbols-outlined shrink-0 text-red-600"
    ></mat-icon>
    <ul class="m-0 flex list-none flex-col gap-1 p-0">
      @for (translationKey of translationKeys(); track translationKey) {
        <li>{{ translationKey | translate }}</li>
      }
    </ul>
  </div>
}
